<template>
  <div>
    <div class="flex items-center mb-4">
      <span
        class="text-grey-darker mr-2 text-2xl cursor-pointer"
        @click="$router.push({name: 'dashboard'})"
      >Veranstaltungen</span>
      <font-awesome-icon icon="chevron-right"></font-awesome-icon>
      <span class="text-3xl ml-2" v-text="event.title"></span>
    </div>
    <div class="mb-8">
      <div class="flex">
        <span class="item-center mr-2 text-gray-900">
          <font-awesome-icon icon="calendar"></font-awesome-icon>
        </span>
        <span class="item-center">{{event.start_date | date}} Uhr</span>
      </div>

      <div>
        <span class="item-center mr-2 text-gray-900">
          <font-awesome-icon icon="map-marker-alt"></font-awesome-icon>
        </span>
        <span>{{event.venue.name}} - {{event.venue.city}}</span>
      </div>
    </div>
    <div class="trix-content" v-html="event.description"></div>
  </div>
</template>


<script>
// import ReservationForm from '../../components/reservation-form/ReservationForm'
import dayjs from "dayjs";

export default {
  props: ["event"],
  filters: {
    date(value) {
      return dayjs(value).format("dddd, DD MMMM YYYY HH:mm");
    }
  }
  //
  // components: {
  //     'reservation-form': ReservationForm,
  // }
};
</script>


<style>
.trix-content blockquote {
  margin: 0 0 0 0.3em;
  padding: 0 0 0 0.6em;
  border-left: 0.3em solid #ccc;
}

.trix-content ul {
  @apply .list-disc;
}

.trix-content ol {
  @apply .list-decimal;
}

.trix-content strong {
  @apply .font-semibold;
}

.trix-content a {
  @apply .text-blue-500;
}

.trix-content a:hover {
  @apply .underline;
}

.trix-content h1 {
  font-size: 1.2em;
  line-height: 1.2;
  margin: 0;
}
</style>